var _Path, _Path2, _Path3, _Path4, _Defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { Path, Defs, LinearGradient, Stop } from "react-native-svg";
var SvgGooglePlay = function SvgGooglePlay(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    width: 26,
    height: 28,
    viewBox: "0 0 26 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _Path || (_Path = /*#__PURE__*/React.createElement(Path, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.052 16.93 5.721 27.05a3.35 3.35 0 0 1-4.97-2.932V3.875A3.35 3.35 0 0 1 5.721.942l18.331 10.121a3.35 3.35 0 0 1 0 5.867Z",
    fill: "url(#paint0_linear)"
  })), _Path2 || (_Path2 = /*#__PURE__*/React.createElement(Path, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m2.485 27.052 12.724-13.296 5.065 5.26L5.721 27.05a3.317 3.317 0 0 1-3.236.002Z",
    fill: "url(#paint1_linear)"
  })), _Path3 || (_Path3 = /*#__PURE__*/React.createElement(Path, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.146 8.906 5.72.942A3.314 3.314 0 0 0 2.624.868L15.207 13.76l4.939-4.854Z",
    fill: "url(#paint2_linear)"
  })), _Path4 || (_Path4 = /*#__PURE__*/React.createElement(Path, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m.751 7.19.023-3.716A3.328 3.328 0 0 1 2.623.87l12.586 12.886L2.53 27.077a3.324 3.324 0 0 1-1.78-2.96V7.19Z",
    fill: "url(#paint3_linear)"
  })), _Defs || (_Defs = /*#__PURE__*/React.createElement(Defs, null, /*#__PURE__*/React.createElement(LinearGradient, {
    id: "paint0_linear",
    x1: 8.397,
    y1: 0.525,
    x2: 8.397,
    y2: 11.009,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement(Stop, {
    stopColor: "#FBDA09"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 1,
    stopColor: "#FFBC00"
  })), /*#__PURE__*/React.createElement(LinearGradient, {
    id: "paint1_linear",
    x1: 9.176,
    y1: 11.732,
    x2: 0.919,
    y2: 23.999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement(Stop, {
    stopColor: "#F2414E"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 1,
    stopColor: "#E02554"
  })), /*#__PURE__*/React.createElement(LinearGradient, {
    id: "paint2_linear",
    x1: 0.612,
    y1: 7.388,
    x2: 8.705,
    y2: 18.095,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement(Stop, {
    stopColor: "#28D781"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 1,
    stopColor: "#02F076"
  })), /*#__PURE__*/React.createElement(LinearGradient, {
    id: "paint3_linear",
    x1: 2.153,
    y1: 25.276,
    x2: 12.706,
    y2: 23.648,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement(Stop, {
    stopColor: "#01E2FF"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 1,
    stopColor: "#01C4FF"
  })))));
};
export default SvgGooglePlay;